<template lang="pug">
.v-advertiser-choice.advertiser-choice(v-if="data")
	.advertiser-choice__modal-nav.modal-nav
		button.modal-nav__back.js-close-modal(type="button")
			v-svg-icon.modal-nav__back-icon(icon="arrow-left")
		button.modal-nav__close.js-close-modal-gallery(type="button")
			v-svg-icon.modal-nav__close-icon(icon="close")
	h1.advertiser-modal__title-text(v-if="data.title" ) {{ data.title }}
	.advertiser-choice__tabs
		v-form(:data-source="data")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>